import { render, staticRenderFns } from "./fund-promo-panel.vue?vue&type=template&id=88605b2a&scoped=true&"
var script = {}
import style0 from "../../../assets/styles/panels/_PromoPanel.scss?vue&type=style&index=0&id=88605b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88605b2a",
  null
  
)

export default component.exports